<template>
  <v-card class="a-kpi-sub pa-2 pa-xl-3 text-center" outlined v-on="$listeners">
    <h3 v-if="title" class="text-caption text-capitalize">{{ title }}</h3>

    <h4 class="text-h5">
      {{ format(value) }}
      <sup
        v-if="delta"
        :class="{
          negative: delta < 0
        }"
      >
        {{ delta > 0 ? "+" : "" }}{{ Math.round(delta) }}%
      </sup>
    </h4>
  </v-card>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    format: {
      type: Function,
      default: v => v
    },
    delta: {
      type: Number,
      default: null
    },
    title: {
      type: String,
      default: null
    }
  }
};
</script>

<style lang="scss">
.a-kpi-sub {
  h4 {
    sup {
      font-size: 0.8rem;
      font-weight: bold;
      color: var(--v-darkGreen-lighten1);

      top: -0.8em;
      margin-left: -0.25em;

      &.negative {
        color: var(--v-error-darken2);
      }
    }
  }

  &.v-card--link:hover {
    background: var(--v-lightGrey-base);
  }
}
</style>
